<template>
  <BaseDataIterator ref="dataList" :service="fetchFacebookCampaigns" disable-search>
    <template #default="{ data }">
      <BaseDataTable :data="data">
        <template #header>
          <FacebookCampaignListHeader />
        </template>

        <template #default="{ item }">
          <FacebookCampaignListItem
            :account-id="accountId"
            :facebook-campaign="item"
            :key="item.id"
          />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { omit } from 'lodash-es';
import {
  accountFacebookCampaignsClient,
  accountFacebookCampaignInsightsClient,
} from '@/api/clients';
import FacebookCampaignListHeader from './FacebookCampaignListHeader.vue';
import FacebookCampaignListItem from './FacebookCampaignListItem.vue';

export default {
  components: {
    FacebookCampaignListHeader,
    FacebookCampaignListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    since: {
      type: String,
      default: '',
    },
    until: {
      type: String,
      default: '',
    },
  },
  methods: {
    async fetchFacebookCampaigns(params) {
      const facebookCampaignsResponse = await accountFacebookCampaignsClient.list(this.accountId, {
        ...params,
        filter: {
          ...(params?.filter || {}),
          ...(this.since && this.until
            ? { having_insights_between: [this.since, this.until].join(',') }
            : {}),
        },
      });

      const id = (facebookCampaignsResponse?.data || []).map((item) => item.id);

      if (id.length === 0) {
        return facebookCampaignsResponse;
      }

      const facebookCampaignInsightsResponse = await accountFacebookCampaignInsightsClient.list(
        this.accountId,
        {
          include: 'contact_requests_count',
          filter: {
            id,
            ...(this.since && this.until ? { since: this.since, until: this.until } : {}),
          },
          aggregated: 1,
        }
      );

      facebookCampaignsResponse.data = facebookCampaignsResponse.data.map((campaign) => {
        const insights = (facebookCampaignInsightsResponse?.data || []).find(
          (insights) => insights.facebook_campaign_id === campaign.id
        ) || {
          spend: 0,
          impressions: 0,
          reach: 0,
          clicks: 0,
          inline_link_clicks: 0,
          account_currency: 'EUR',
          contact_requests_count: 0,
        };

        campaign.insights = insights ? omit(insights, ['facebook_campaign_id']) : null;

        return campaign;
      });

      return facebookCampaignsResponse;
    },
  },
};
</script>
